<template>
  <div class="tags has-addons mt-3">
    <span class="tag is-medium is-light">CPU</span>
    <span
      class="tag is-medium"
      :class="priceTagColor(worker.cost_cpu_hour)"
      >{{ worker.cost_cpu_hour }}</span
    >
    <span class="tag is-medium is-light">€ / h</span>
  </div>

  <div class="tags has-addons mt-3">
    <span class="tag is-medium is-light">GPU</span>
    <span
      class="tag is-medium"
      :class="priceTagColor(worker.cost_gpu_hour)"
      >{{ worker.cost_gpu_hour }}</span
    >
    <span class="tag is-medium is-light">€ / h</span>
  </div>

  <div class="tags has-addons mt-3">
    <span
      class="tag is-medium"
      :class="priceTagColor(worker.cost_1k_elements)"
      >{{ worker.cost_1k_elements }}</span
    >
    <span class="tag is-medium is-light">€ / 1000 elements</span>
  </div>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type { Worker } from '@/types/worker'

export default defineComponent({
  props: {
    worker: {
      type: Object as PropType<Worker>,
      required: true,
    },
  },
  methods: {
    priceTagColor(value: string) {
      if (parseFloat(value) > 0) return 'is-warning'
      return 'is-info is-light'
    },
  },
})
</script>
